import type { QuestionnaireApi, GetQuestionnairesApiQuery } from "@/Modules/Models/Api/Questionnaire";
import type { PaginatedApiResponse } from "./utils/interfaces";
import type { CreateQuestionnaireApiQuery } from "@/Modules/Models/Api/Questionnaire";
import type { QuestionnaireSummaryApi } from "@/Modules/Models/Api/Questionnaire";
import type { SendQuestionnaireApiQuery } from "@/Modules/Models/Api/Questionnaire";
import type { QuestionnaireAnswersApi } from "@/Modules/Models/Api/Questionnaire";
import type { AnswersApiQuery } from "@/Modules/Models/Api/Questionnaire";

import TherapySideApiService from "./utils/TherapyApi";

class QuestionnariesApiConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  getAll(query: GetQuestionnairesApiQuery): Promise<PaginatedApiResponse<QuestionnaireApi>> {
    return this.ApiService.get<GetQuestionnairesApiQuery, PaginatedApiResponse<QuestionnaireApi>>({
      endpoint: `/v1.0/questionnaires`,
      params: query,
      responseParams: { raw: true },
    });
  }

  getById(id: string): Promise<QuestionnaireApi> {
    return this.ApiService.get<void, QuestionnaireApi>({
      endpoint: `/v1.0/questionnaires/${id}`,
    });
  }

  createQuestionnaire(
    aboutUuid: string,
    whoUuid: string,
    userUuid: string,
    questionnaireUuid: string
  ): Promise<QuestionnaireSummaryApi> {
    return this.ApiService.post<CreateQuestionnaireApiQuery, QuestionnaireSummaryApi>({
      endpoint: "v1.0/users/" + userUuid + "/questionnaires",
      body: {
        about_uuid: aboutUuid,
        who_uuid: whoUuid,
        questionnaire_uuid: questionnaireUuid,
      },
    });
  }

  getQuestionnairesByUserId(
    userId: string,
    query: GetQuestionnairesApiQuery
  ): Promise<PaginatedApiResponse<QuestionnaireSummaryApi>> {
    return this.ApiService.get<GetQuestionnairesApiQuery, PaginatedApiResponse<QuestionnaireSummaryApi>>({
      endpoint: `/v3.0/users/${userId}/questionnaires`,
      params: query,
      responseParams: { raw: true },
    });
  }

  sendQuestionnaire(userUuid: string, questionnaireUuid: string): Promise<QuestionnaireSummaryApi> {
    return this.ApiService.post<SendQuestionnaireApiQuery, QuestionnaireSummaryApi>({
      endpoint: "v1.0/users/" + userUuid + "/questionnaires",
      body: {
        questionnaire_uuid: questionnaireUuid,
      },
    });
  }

  getQuestionnaireAnswers(query: AnswersApiQuery): Promise<QuestionnaireAnswersApi> {
    return this.ApiService.get<AnswersApiQuery, QuestionnaireAnswersApi>({
      endpoint: `/v1.0/answers`,
      params: query,
    });
  }
}

export default QuestionnariesApiConnector;
